import { Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SwipeableViews from "react-swipeable-views";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { useGetSubscription } from "@common/SelectYourNumber/hook/useGetSubscription";
import { Stepper } from "@common/Stepper/Stepper";
import { UserDetailsPage } from "@features/Profile/UserDetails/UserDetailsPage";
import { ContactPreferencePage } from "@features/Profile/ContactPreference/ContactPreferencePage";
import { NationalDirectoryEnquiriesPage } from "@features/Profile/NationalDirectoryEnquiries/NationalDirectoryEnquiriesPage";

export const ProfilePage = () => {
    const [step, setStep] = useState(0);
    const { selectedService } = useGetSubscription(true);
    const { t } = useTranslation("navigation");

    useEffect(() => {
        window.scrollTo(0, 150);
    }, [step]);

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                    {t("myProfile")}
                </Typography>
                <SwipeableViews
                    animateHeight={step !== 0}
                    axis="x"
                    index={step}
                    slideStyle={{ padding: "10px 0", overflowY: "auto" }}
                    onChangeIndex={setStep}
                >
                    <div>
                        <UserDetailsPage />
                    </div>
                    <div>
                        <ContactPreferencePage />
                    </div>
                    {selectedService ? (
                        <div>
                            <NationalDirectoryEnquiriesPage />
                        </div>
                    ) : (
                        // eslint-disable-next-line react/jsx-no-useless-fragment
                        <Fragment />
                    )}
                </SwipeableViews>
                <Stepper activeStep={step} handleStepChange={setStep} stepsLength={selectedService ? 3 : 2} />
            </div>
        </Fragment>
    );
};
